const API = {
  GET_EXCHANGE_RATES: {
    path: '/global-config/exchange-rates',
    method: 'GET',
  },

};

export default API;
